import React, { Fragment } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  LinkProps,
  Link,
  IconButton,
  Box,
  Stack
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink } from 'react-router-dom';

import { useHasRole } from '@homesusa/auth';
import { HeaderUser } from '../header-user/header-user.component';
import { Root, classes } from './header.style';
import { AppContext } from '../../contexts';
import { AppType } from '../../enums';
import { HeaderKpi } from '../header-kpi/header-kpi.component';
import { ContactForm } from '../contact-form.component';
import { WorkLinks } from '../work-links.component';

export function Header(): JSX.Element {
  const {
    appState: {
      currentApp,
      apps: { quicklister },
      layout: { header }
    },
    appStateDispatch
  } = React.useContext(AppContext);
  const logoUrl = 'https://homesusastorage.blob.core.windows.net/webimages/SpecDeck-White-Logo.svg';
  const host = window.location.protocol + '//' + window.location.host;
  const isQL = currentApp === AppType.Quicklister;
  const linkLogoProps = {
    component: isQL ? RouterLink : 'a',
    ...(isQL && { to: '/' }),
    ...(!isQL && { href: quicklister })
  };
  const handleDrawerOpen = (): void => appStateDispatch({ type: 'OpenSubSideBar' });
  const linkProps: LinkProps = { underline: 'none' };
  const { isMlsAdministrator } = useHasRole();
  return (
    <Root className={classes.root}>
      <AppBar position='fixed' className={classes.appbar}>
        <Toolbar className={classes.toolbar}>
          <IconButton onClick={handleDrawerOpen} color='inherit' aria-label='open drawer'>
            <MenuIcon />
          </IconButton>
          <div className={classes.logo}>
            <Link {...linkLogoProps}>
              <img src={logoUrl} alt='logo' />
            </Link>
          </div>
          <Typography className={classes.links}>
            <Link {...linkProps} to='/help' component={RouterLink}>
              Support Videos
            </Link>
            {isMlsAdministrator && <WorkLinks />}
            {header?.links && (
              <Fragment>
                {header.links.map((option) => {
                  return option.url.startsWith(host) ? (
                    <Link
                      {...linkProps}
                      to={option.url.replace(host, '')}
                      key={option.url}
                      component={RouterLink}
                    >
                      {option.title}
                    </Link>
                  ) : (
                    <Link {...linkProps} href={option.url} key={option.url} target='_blank'>
                      {option.title}
                    </Link>
                  );
                })}
              </Fragment>
            )}
          </Typography>

          <Box className={classes.flex}>
            <Box className={classes.kpi}>
              <Stack direction='row' justifyContent='flex-end' alignItems='center' spacing={1.5}>
                {isQL && isMlsAdministrator && <HeaderKpi />}
                <ContactForm />
                <HeaderUser />
              </Stack>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </Root>
  );
}
